import { Text, TipMessage } from '../../common/components';
import { t } from '../../common/i18n';
import { ServicePartner } from '../types';

const namespace = 'OtherServices';

interface PreviewNoticeProps {
  /** Token náhledu z URL – bez něj se nic nevykreslí. */
  preview: string | null;
  partners: ServicePartner[];
}

/**
 * Upozornění nad katalogem při náhledu přes `?preview=<token>` (odkaz z back-office): kterého
 * nezveřejněného partnera vidíme navíc. Běžný uživatel bez tokenu banner nikdy neuvidí.
 */
export const PreviewNotice: React.FC<PreviewNoticeProps> = ({ preview, partners }) => {
  if (!preview) return null;

  const previewPartners = partners.filter((partner) => partner.isPreview);

  return (
    <TipMessage variant="warning" title={t('Preview.title', namespace)} className="ServiceCatalog__preview">
      {previewPartners.map((partner) => (
        <Text key={partner.slug} as="p" size="body-small" color="Neutral800">
          {t('Preview.text', namespace, { name: partner.name })}
        </Text>
      ))}
      {previewPartners.length === 0 && (
        <Text as="p" size="body-small" color="Neutral800">
          {t('Preview.none', namespace)}
        </Text>
      )}
    </TipMessage>
  );
};

export default PreviewNotice;
